import {Ticket} from "../reducers/ticket";

/**
 * Outstanding amount shown to the violator. The backend computes `remainingAmount` with the same country rules
 * as the invoice and the online payment, so the portal must not rebuild it. The legacy formula below is only a
 * fallback for a backend that does not send the field yet.
 */
export const outstandingAmount = (ticket: Ticket): number => {
    if (ticket.gasStationZone == null && ticket.status === "PAID") {
        return ticket.paidAmount ? 0 : ticket.amount;
    }
    if (ticket.remainingAmount != null) {
        return ticket.remainingAmount;
    }
    if (ticket.gasStationZone != null) {
        return ticket.totalGasStationAmount - ticket.paidAmount;
    }
    return ticket.reminderDeadline
        ? ticket.amount + ticket.reminderFee + ticket.additionalCost - ticket.paidAmount
        : ticket.amount - ticket.paidAmount;
};
